import Vue from 'vue'

import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'

// rph addons
import RPHSlides from 'rph-slides-vue/src/rph-slides-vue.js'
// import ApiCacheAddon from '@/addons/rph/apiCache/ApiCacheAddon.js'
// ms addons
// import MsList from '@/components/List.vue'
// import MsSlide from '@/components/Slide.vue'
// import PlayerSettings from '@/components/players/PlayerSettings.vue'

// import BuildingDataExplorerAddon from '@/plugins/building/ExplorerAddon.js'
// import OpenWeatherAddon from '@/plugins/openWeather/WeatherAddon.js'
// import TwitterAddon from '@/plugins/twitter/TwitterAddon.js'
import SxswScraperAddon from '@/plugins/sxswScraper/SxswScraperAddon.js'
import SxswAddon from '@/plugins/sxsw/SxswAddon.js'
import ZeroxaAddon from '@/plugins/zeroxa/ZeroxaAddon.js'

import OpenWeatherModule from '@/components/slides/modules/OpenWeatherModule.vue'
import SxswEventsKeywordsModule from '@/components/slides/modules/SxswEventsKeywordsModule.vue'
import SxswScraperEventsImagesModule from '@/components/slides/modules/SxswScraperEventsImagesModule.vue'
import VideoModule from '@/components/slides/modules/VideoModule.vue'
import ZeroxaModule from '@/components/slides/modules/ZeroxaModule.vue'
import ZeroxaNFTModule from '@/components/slides/modules/ZeroxaNFTModule.vue'
import ZeroxaPOAPModule from '@/components/slides/modules/ZeroxaPOAPModule.vue'

// import SettingsModule from 'rph-slides-vue/src/components/slides/modules/JsonModule.vue'

import moment from 'moment-timezone'
import VueMoment from 'vue-moment'
// moment.tz.setDefault('America/New_York')
// moment.tz.setDefault('America/Toronto')

Vue.config.productionTip = false

const config = {
  auth: {
    connection: true,
    user: false
  },
  lists: {
    showPlaytime: false
  },
  slides: {
    // status: {
    //   // approved: 'Approved!',
    //   unityRendering: 'Unity exporting',
    //   unityRenderingComplete: 'Unity export complete',
    //   processing: 'Exports processing',
    //   processingComplete: 'Exports processing complete',
    //   uploading: 'Azure upload in progress',
    //   uploadingComplete: 'Azure upload complete',
    //   complete: 'Complete'
    // },
    defaultModel: {
      name: 'Name me!',
      template: '',
      duration: 30,
      introDuration: 0.5,
      outroDuration: 0.5,
      status: 'approved',
      modules: []
    },
    templates: {
      chapterLoading: {
        name: 'Chapter: Loading',
        template: 'template-general',
        settings: [
          { type: 'ChapterLoadingSettingsModule', title: 'Loading Settings', required: false, multiple: false, defaultModel: { type: 'ChapterLoadingSettingsModule' } }
        ],
        defaultModel: { duration: 15, introDuration: 0.5, outroDuration: 0.5, modules: [{ type: 'ChapterLoadingSettingsModule' }] }
      },
      chapterTransactions: {
        name: 'Chapter: Transactions',
        template: 'template-general',
        settings: [
          { type: 'ChapterTransactionsSettingsModule', title: 'Transaction Settings', required: false, multiple: false, defaultModel: { type: 'ChapterTransactionsSettingsModule' } },
          { type: 'ZeroxaModule', required: true, multiple: false, defaultModel: ZeroxaModule.defaultModel }
        ],
        defaultModel: { duration: 30, introDuration: 1, outroDuration: 1, modules: [{ type: 'ChapterTransactionsSettingsModule' }, ZeroxaModule.defaultModel] }
      },
      chapterThoughts: {
        name: 'Chapter: Thoughts',
        template: 'template-general',
        settings: [
          { type: 'ChapterThoughtsSettingsModule', title: 'Thoughts Settings', required: false, multiple: false, defaultModel: { type: 'ChapterThoughtsSettingsModule' } },
          { type: 'SxswEventsKeywordsModule', required: true, multiple: false, defaultModel: SxswEventsKeywordsModule.defaultModel }
        ],
        defaultModel: { duration: 30, introDuration: 1, outroDuration: 1, modules: [{ type: 'ChapterThoughtsSettingsModule' }, SxswEventsKeywordsModule.defaultModel] }
      },
      chapterPresence: {
        name: 'Chapter: Presence',
        template: 'template-general',
        settings: [
          { type: 'ChapterPresenceSettingsModule', title: 'Presence Settings', required: false, multiple: false, defaultModel: { type: 'ChapterPresenceSettingsModule' } },
          { type: 'ZeroxaPOAPModule', required: true, multiple: false, defaultModel: ZeroxaPOAPModule.defaultModel }
        ],
        defaultModel: { duration: 30, introDuration: 1, outroDuration: 1, modules: [{ type: 'ChapterPresenceSettingsModule' }, ZeroxaModule.defaultModel] }
      },
      chapterEvents: {
        name: 'Chapter: Events',
        template: 'template-general',
        settings: [
          { type: 'ChapterEventsSettingsModule', title: 'Events Settings', required: false, multiple: false, defaultModel: { type: 'ChapterEventsSettingsModule' } },
          { type: 'SxswScraperEventsImagesModule', required: true, multiple: false, defaultModel: SxswScraperEventsImagesModule.defaultModel }
        ],
        defaultModel: { duration: 30, introDuration: 1, outroDuration: 1, modules: [{ type: 'ChapterEventsSettingsModule' }, SxswScraperEventsImagesModule.defaultModel] }
      },
      chapterFinale: {
        name: 'Chapter: Finale',
        template: 'template-general',
        settings: [
          { type: 'ChapterFinaleSettingsModule', title: 'Finale Settings', required: false, multiple: false, defaultModel: { type: 'ChapterFinaleSettingsModule' } },
          { type: 'VideoModule', required: true, multiple: false, defaultModel: VideoModule.defaultModel }
        ],
        defaultModel: { duration: 30, introDuration: 1, outroDuration: 1, modules: [{ type: 'ChapterFinaleSettingsModule' }, VideoModule.defaultModel] }
      },
      openweather: {
        name: 'Open Weather',
        template: 'template-general',
        sortable: true,
        settings: [
          // { type: 'WTImageModule', required: false, multiple: true, defaultModel: WTImageModule.defaultModel }
          { type: 'OpenWeatherModule', required: true, multiple: false, defaultModel: OpenWeatherModule.defaultModel }
        ],
        defaultModel: [OpenWeatherModule.defaultModel]
      },
      sxsw: {
        name: 'Sxsw Events',
        template: 'template-general',
        sortable: true,
        settings: [
          // { type: 'WTImageModule', required: false, multiple: true, defaultModel: WTImageModule.defaultModel }
          { type: 'SxswEventsKeywordsModule', required: true, multiple: false, defaultModel: SxswEventsKeywordsModule.defaultModel }
        ],
        defaultModel: [SxswEventsKeywordsModule.defaultModel]
      }
    }
  }
  // players: {
  //   list: {
  //     editComponent: 'PlayerSettings',
  //     columns: [
  //       // { label: 'playerId', prop: 'playerId' },
  //       // { label: 'currentListId', component: { name: 'PlayersListItemListId', props: { list: 'currentListId' } } }
  //     ]
  //   }
  // }
}

// Vue.component('MsList', MsList)
// Vue.component('MsSlide', MsSlide)
// Vue.component('PlayerSettings', PlayerSettings)

Vue.component('OpenWeatherModule', OpenWeatherModule)
Vue.component('SxswEventsKeywordsModule', SxswEventsKeywordsModule)
Vue.component('SxswScraperEventsImagesModule', SxswScraperEventsImagesModule)
Vue.component('VideoModule', VideoModule)
Vue.component('ZeroxaModule', ZeroxaModule)
Vue.component('ZeroxaNFTModule', ZeroxaNFTModule)
Vue.component('ZeroxaPOAPModule', ZeroxaPOAPModule)

// Vue.component('ChapterLoadingSettingsModule', SettingsModule)
// Vue.component('ChapterTransactionsSettingsModule', SettingsModule)

// add all default nav items to main nav
store.dispatch('nav/addToNav', { label: 'Status', to: '/' })
store.dispatch('nav/addToNav', { label: 'Lists', to: '/lists' })
// store.dispatch('nav/addToNav', { label: 'Edit', to: '/lists/edit' })
// store.dispatch('nav/addToNav', { label: 'Settings', to: '/settings' })
store.dispatch('nav/addToNav', { label: 'Players', to: '/players' })
store.dispatch('nav/addToNav', { label: 'Test API', to: '/test' })
// store.dispatch('nav/addToNav', { label: 'Remote Control', to: '/remote' })

if (window.user) {
  // console.log('yes yes, user:', window.user)
  store.commit('user/setUser', window.user)
}
if (window.token) {
  // console.log('yes yes, token:', window.token)
  store.commit('auth/setToken', window.token)
}

// initialize addons
Vue.use(VueMoment, { moment })
Vue.use(RPHSlides, { router, store, config })
Vue.use(SxswAddon)
Vue.use(SxswScraperAddon)
// Vue.use(TwitterAddon)
// Vue.use(OpenWeatherAddon)
Vue.use(ZeroxaAddon)

// Vue.use(ApiCacheAddon, { socket })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
